export default __webpack_public_path__ + "static/media/logo.106b7cf7.png";